import ActivityTab from './ActivityTab';
import CommentItem from '../items/CommentItem';

const isActiveComment = (item) => item.category?.trim().toLowerCase() !== 'news';

const CommentTab = ({ api, userId }) => (
  <ActivityTab
    api={api}
    userId={userId}
    ItemComponent={CommentItem}
    includeItem={isActiveComment}
    itemKey="comment.id"
    readOnly
  />
);

export default CommentTab;
